import { getAllUrlVariables } from '../../utils/get-url-variables';
import Base from '../base';

import {
	default as TurbomapFilters,
	FILTERS_CHANGED_EVENT,
	FILTERS_RESET_EVENT,
} from './turbomap-filters';
import Turbomap from './turbomap';

import './turbomap-product-detail';

class TurbomapPage extends Base {
	start() {
		this.filters = new TurbomapFilters(this.el.querySelector('.js-filters'));
		this.turbomap = new Turbomap(this.el.querySelector('.js-turbomap'));

		this.filters.el.addEventListener(FILTERS_CHANGED_EVENT, e => this.onFiltersSubmit(e));
		this.filters.el.addEventListener(FILTERS_RESET_EVENT, e => this.onFiltersReset(e));

		window.addEventListener('popstate', e => this.onPopState());

		this.pageInit();
	}

	onPopState() {
		// don't take filled form values into account
		// user can fill in stoploss, click back, stoploss is from URL but still filled in
		// by omitting form values, they will be emptied
		const filters = { ...this.getDefaultFilters(), ...getAllUrlVariables() };

		this.filters.set(filters);
		this.update(filters);
	}

	pageInit() {
		const initialFilters = this.getInitialFilters();
		const queryString = TurbomapPage.createQueryString(initialFilters);

		this.filters.set(initialFilters);

		TurbomapPage.updateURL(queryString);

		this.update(initialFilters);
	}

	onFiltersReset() {
		TurbomapPage.updateURL('');

		this.pageInit();
	}

	onFiltersSubmit() {
		const appliedFilters = this.filters.getFilterValues();
		const queryString = TurbomapPage.createQueryString(appliedFilters);

		TurbomapPage.updateURL(queryString);

		this.update(appliedFilters);
	}

	update(appliedFilters) {
		this.turbomap.load(appliedFilters);
	}

	getDefaultFilters() {
		const defaultFilters = {
			underlyingId: this.options.defaultUnderlyingId,
			shouldFilterForWarrants: this.options.shouldFilterForWarrants,
		};

		return defaultFilters;
	}

	// get form values
	// override with default filters
	// override with filters in URL
	getInitialFilters() {
		const defaultFilters = this.getDefaultFilters();
		const urlFilters = getAllUrlVariables();

		return { ...defaultFilters, ...urlFilters };
	}

	static createQueryString(filters) {
		const urlParams = new URLSearchParams();

		for (const [key, value] of Object.entries(filters)) {
			if (value) {
				urlParams.append(key, value);
			}
		}

		return urlParams.toString();
	}

	static updateURL(queryString) {
		history.pushState(null, null, `?${queryString}`);
	}
}

export default TurbomapPage;
